import React from "react";

import { Typography, IconWrapper } from "@king-ict/eupisi-ui/components";
import { ReactComponent as MenuMoreIcon } from "@king-ict/eupisi-ui/components/Icon/MenuMore.svg";
import { useBreakpoint } from "@king-ict/eupisi-ui/hooks";
import { useTranslation } from "react-i18next";

import styles from "./RequestStepperHeader.module.scss";
import { RequestStepperHeaderButtons } from "./RequestStepperHeaderButtons";

interface Props {
  currentStep: number;
  currentSubstep?: number;
  openMobileMenu: () => void;
}

export default function RequestStepperHeader({
  currentStep,
  currentSubstep,
  openMobileMenu,
}: Props) {
  const { t } = useTranslation();
  const sizeBreakpoint = useBreakpoint();

  return (
    <>
      <div className={styles.requestHeader}>
        {sizeBreakpoint === "xs" || sizeBreakpoint === "sm" ? (
          <div className={styles.requestTitleRow}>
            <Typography component="h1" className={styles.title}>
              {t("request.requestTitle")}
            </Typography>
            <div className={styles.more} onClick={openMobileMenu}>
              <IconWrapper color="primary">
                <MenuMoreIcon />
              </IconWrapper>
            </div>
          </div>
        ) : (
          <Typography component="h1" className={styles.title}>
            {t("request.requestTitle")}
          </Typography>
        )}

        {sizeBreakpoint !== "xs" && sizeBreakpoint !== "sm" ? (
          <div className={styles.headerButtons}>
            <RequestStepperHeaderButtons
              currentStep={currentStep}
              currentSubstep={currentSubstep}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
